module.exports = __webpack_public_path__ + "9410c9435728b4f1d987e487a570cb45.MP3";